var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h4', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v("感謝頁")]), _vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "disabled": _vm.isReadOnly
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" Banner "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 700px")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_vm.selectedImage ? _c('li', {
          staticClass: "s-image-list-item s-draggable"
        }, [_c('img', {
          staticClass: "s-cropped-image",
          attrs: {
            "src": _vm.selectedImage
          }
        }), _c('button', {
          staticClass: "btn btn-danger s-delete-btn",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.selectedImage = null;
            }
          }
        }, [_vm._v(" Ｘ ")])]) : _c('li', {
          staticClass: "s-image-list-item"
        }, [_c('ImageSelector', {
          attrs: {
            "aspect-ratio": 1400 / 700
          },
          on: {
            "input": function input(croppedImage) {
              return _vm.selectedImage = croppedImage;
            }
          },
          scopedSlots: _vm._u([{
            key: "trigger",
            fn: function fn(_ref) {
              var openFileSelector = _ref.openFileSelector;
              return [_c('button', {
                staticClass: "btn s-trigger-btn",
                on: {
                  "click": openFileSelector
                }
              }, [_vm._v(" ＋ 加入照片 ")])];
            }
          }])
        })], 1)];
      },
      proxy: true
    }])
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "標題",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.config.thanks_page.form_title.$error') ? false : null
    },
    model: {
      value: _vm.form.config.thanks_page.form_title,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.thanks_page, "form_title", $$v);
      },
      expression: "form.config.thanks_page.form_title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.thanks_page.form_title.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "副標題",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.config.thanks_page.form_desc.$error') ? false : null
    },
    model: {
      value: _vm.form.config.thanks_page.form_desc,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.thanks_page, "form_desc", $$v);
      },
      expression: "form.config.thanks_page.form_desc"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.thanks_page.form_desc.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "內容說明",
      "disabled": _vm.isReadOnly
    }
  }, [_c('TrixEditor', {
    attrs: {
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.thanks_page.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.thanks_page, "content", $$v);
      },
      expression: "form.config.thanks_page.content"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.thanks_page.content.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "按鈕文字",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.config.thanks_page.button_text.$error') ? false : null
    },
    model: {
      value: _vm.form.config.thanks_page.button_text,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.thanks_page, "button_text", $$v);
      },
      expression: "form.config.thanks_page.button_text"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.thanks_page.button_text.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "*表單類型(尚未串接)",
      "disabled": _vm.isReadOnly
    }
  }, [_c('div', {
    staticClass: "radio-button-group-grid mt-1"
  }, [_c('b-form-radio', {
    attrs: {
      "name": "button_action",
      "id": "OA",
      "value": "OA"
    },
    on: {
      "input": _vm.cleanButtonUrl
    },
    model: {
      value: _vm.form.config.thanks_page.button_action,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.thanks_page, "button_action", $$v);
      },
      expression: "form.config.thanks_page.button_action"
    }
  }), _c('div', {
    staticClass: "radio-button-group-grid__option-content"
  }, [_c('label', {
    staticClass: "mb-0",
    attrs: {
      "for": "OA"
    }
  }, [_vm._v("回官方帳號")])]), _c('b-form-radio', {
    attrs: {
      "name": "button_action",
      "id": "URL",
      "value": "URL"
    },
    on: {
      "input": _vm.cleanButtonUrl
    },
    model: {
      value: _vm.form.config.thanks_page.button_action,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.thanks_page, "button_action", $$v);
      },
      expression: "form.config.thanks_page.button_action"
    }
  }), _c('div', {
    staticClass: "radio-button-group-grid__option-content"
  }, [_c('label', {
    staticClass: "mb-0",
    attrs: {
      "for": "URL"
    }
  }, [_vm._v("自訂網址")]), _c('b-form-input', {
    staticClass: "ml-3",
    attrs: {
      "type": "text",
      "disabled": _vm.form.config.thanks_page.button_action !== 'URL',
      "state": _vm.deepGet(_vm.v$, 'form.config.thanks_page.button_url.$error') ? false : null
    },
    model: {
      value: _vm.form.config.thanks_page.button_url,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.thanks_page, "button_url", $$v);
      },
      expression: "form.config.thanks_page.button_url"
    }
  })], 1)], 1)]), !_vm.isReadOnly ? _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submitPage
    }
  }, [_vm._v(" 儲存 ")])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }